import { NeedleIcon } from './NeedleIcon';

/**
 * author: Austin Andrews
 * id 2B76647F-92FE-4F8E-B193-7EC20DADD5D2
 * name needle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/needle.svg
 * tags
 * - Medical / Hospital 
 */
export const InjectionIcon = NeedleIcon;
export default InjectionIcon